'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('app_custom_mufe/product/pdpRework/productDetail'));
    processInclude(require('app_custom_mufe/product/pdpRework/productTile'));
    processInclude(require('app_custom_mufe/product/pdpRework/detailElement'));
    processInclude(require('./product/pdpRework/productDetail'));

});
